import { cx } from '@twind/core';
import { ChangeEventHandler, useState } from 'react';
import OstroDynamicContent from 'app/components/OstroDynamicContent';

import { FormItemSingleChoice } from '../types';

type Props = { item: FormItemSingleChoice; isSubmitted: boolean };

export function ContactFormMultiChoice({ item }: Props) {
  const hasErrors = item.errors?.length;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center text-sm gap-1">
        <div dangerouslySetInnerHTML={{ __html: item.label }} />
        {!item.required && <span>(optional)</span>}
      </div>
      <div className="flex flex-col gap-4">
        {item.choices.map((choice: string) => (
          <CheckBox
            key={choice}
            value={item.value as string[]}
            refId={item.ref_id}
            choice={choice}
          />
        ))}
      </div>
      {hasErrors && item.errors?.length ? (
        <div className="text-xs -mt-1 text-[#FF3323]">{item.errors?.join(', ')}</div>
      ) : null}
    </div>
  );
}

type CheckBoxProps = {
  refId: string;
  choice: string;
  value: string[];
};

function CheckBox({ value, refId, choice }: CheckBoxProps) {
  const [checked, setChecked] = useState(!!value?.includes(choice));

  const handleChange: ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    setChecked(target.checked);
  };

  return (
    <label
      className={cx(
        'flex gap-1 items-center border h-[54px] px-[14px] py-3 rounded-[8px]',
        checked ? 'border-[#F0F0F0]' : 'border-typography-divider',
        checked && 'bg-[#F0F0F0]'
      )}
    >
      <OstroDynamicContent
        component="span"
        className="inline text-base grow"
        content={choice}
      />
      {!checked ? (
        <input
          type="hidden"
          name={refId}
          value=""
        />
      ) : null}
      <input
        className="accent-[#000000] shrink-0 h-4 w-4"
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        name={refId}
        value={choice}
      />
    </label>
  );
}
